import { render, staticRenderFns } from "./PulloutMailingMenu.vue?vue&type=template&id=72c0aebe&scoped=true&"
import script from "./PulloutMailingMenu.vue?vue&type=script&lang=js&"
export * from "./PulloutMailingMenu.vue?vue&type=script&lang=js&"
import style0 from "./PulloutMailingMenu.vue?vue&type=style&index=0&id=72c0aebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c0aebe",
  null
  
)

export default component.exports